import type { MindstringPrototype } from "@/generated/fastapi";

export type CriteriaQueryKey = {
  targetId: string;
  prototypeCategory?: MindstringPrototype;
};

export const criteriaKeys = {
  all: ["criteria"] as const,
  list: (key: CriteriaQueryKey) =>
    [...criteriaKeys.all, key.targetId, key.prototypeCategory ?? ""] as const,
};
